import { cloneElement, FC, ReactElement, ReactNode } from 'react'
import { cn } from '@wellesley/ui'

type EventCardDataRowProps = {
  testId?: string
  icon?: ReactElement
  children: ReactNode
  className?: string
}

export const EventCardDataRow: FC<EventCardDataRowProps> = ({
  icon,
  children,
  testId,
  className,
}) => {
  return (
    <div
      data-testid={testId}
      className={cn('flex items-center gap-xxs text-gray-500', className)}
    >
      {icon && cloneElement(icon, { size: 20, className: 'flex-shrink-0' })}
      <div className="overflow-hidden overflow-ellipsis whitespace-nowrap text-base">
        {children}
      </div>
    </div>
  )
}
